module.exports = __webpack_public_path__ + "static/home_03-c7597fddd9ed401c33d195ffe1009ba6.webp";